/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const plot_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeDasharray="2 3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.073 8a.98.98 0 0 1 .958.767l2.424 10.795A2 2 0 0 1 20.503 22H3.501a2 2 0 0 1-1.952-2.438L3.973 8.767A.982.982 0 0 1 4.93 8"
    />
    <path
      fill="#000"
      d="m12.593 13.638-.59-.462h-.001l.591.462Zm-.262.212-.329-.674.329.674Zm-.658 0 .33-.674h-.001l-.329.674Zm-.262-.212.591-.461-.59.461ZM12.002 2v.75a3.75 3.75 0 0 1 2.652 1.098l.53-.53.53-.53a5.25 5.25 0 0 0-3.712-1.538V2Zm3.182 1.318-.53.53A3.75 3.75 0 0 1 15.752 6.5h1.5a5.25 5.25 0 0 0-1.538-3.712l-.53.53ZM16.502 6.5h-.75c0 .329-.121.807-.38 1.412a15.137 15.137 0 0 1-1.006 1.9c-.803 1.314-1.76 2.593-2.364 3.364l.591.462.591.462c.618-.79 1.615-2.12 2.461-3.505.423-.692.817-1.412 1.108-2.095.285-.669.5-1.368.5-2h-.75Zm-3.909 7.138-.591-.461.329.673.328.675c.205-.1.385-.246.525-.425l-.59-.462Zm-.262.212-.33-.674h.001v1.5a1.5 1.5 0 0 0 .658-.152l-.33-.674Zm-.329.076v-.75l-.329.674-.329.674c.205.1.43.152.658.152v-.75Zm-.329-.076.329-.674-.59.462-.592.462c.14.18.32.325.525.425l.328-.675Zm-.262-.212.591-.462c-.603-.771-1.56-2.05-2.363-3.364a15.134 15.134 0 0 1-1.008-1.9c-.257-.605-.379-1.083-.379-1.412h-1.5c0 .632.215 1.331.499 2 .29.683.685 1.403 1.108 2.095.846 1.384 1.843 2.714 2.461 3.505l.591-.462ZM7.502 6.5h.75A3.75 3.75 0 0 1 9.35 3.848l-.53-.53-.53-.53A5.25 5.25 0 0 0 6.752 6.5h.75ZM8.82 3.318l.53.53a3.75 3.75 0 0 1 2.652-1.098v-1.5A5.25 5.25 0 0 0 8.29 2.788l.53.53Zm3.932 2.932h-.75v1.5a1.5 1.5 0 0 0 1.5-1.5h-.75Zm-.75.75v-.75h-1.5a1.5 1.5 0 0 0 1.5 1.5V7Zm-.75-.75h.75v-1.5a1.5 1.5 0 0 0-1.5 1.5h.75Zm.75-.75v.75h1.5a1.5 1.5 0 0 0-1.5-1.5v.75Z"
    />
  </svg>
)
export default plot_medium
